var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6808 8.07635C15.8936 8.37476 16 8.524 16 8.74485C16 8.9657 15.8936 9.11494 15.6808 9.41335C14.7245 10.7543 12.2824 13.6448 9 13.6448C5.71755 13.6448 3.27547 10.7543 2.31923 9.41335C2.10641 9.11494 2 8.9657 2 8.74485C2 8.524 2.10641 8.37476 2.31923 8.07635C3.27547 6.73546 5.71755 3.84485 9 3.84485C12.2824 3.84485 14.7245 6.73546 15.6808 8.07635Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    className: "only-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 8.7449C11.1 7.58507 10.1599 6.6449 9.00002 6.6449C7.84019 6.6449 6.90002 7.58507 6.90002 8.7449C6.90002 9.90473 7.84019 10.8449 9.00002 10.8449C10.1599 10.8449 11.1 9.90473 11.1 8.7449Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    className: "only-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.be08995e700d088aff9073811161e5d8.svg";
export { ForwardRef as ReactComponent };